import model from './model';
import SmartLockLogDetailsPage from './pages/SmartLockLogDetailsPage';

model.routes.setRoutes({
  detailsRoute: {
    component: SmartLockLogDetailsPage,
  },
});
